module.exports = __webpack_public_path__ + "static/media/company.ee9e6417.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/company.svg
// module id = 450
// module chunks = 0